export default () => ({
  ADS_POSITION: {
    PREROLL: 'pre',
    MIDROLL: 'mid',
    POSTROLL: 'post'
  }
});
